module.exports = __webpack_public_path__ + "0169b64494cd99e8eb2672cd473a9baa.pdf";